import { Component, EventEmitter, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Template } from "../../models/template.model";
import { TemplateService } from "../../services/template.service";

@Component({
  selector: "app-delete-template-dialog",
  templateUrl: "./delete-template-dialog.component.html",
  styleUrls: ["./delete-template-dialog.component.scss"],
})
export class DeleteTemplateDialogComponent {
  @Input() template: Template;
  yes: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private readonly templateService: TemplateService,
    readonly activeModal: NgbActiveModal
  ) {}

  onYes() {
    this.activeModal.close();
    this.templateService.delete(this.template.id).then(() => this.yes.emit());
  }

  onNo() {
    this.activeModal.close();
  }
}
